import React from "react";
import styles from "./edit-source-name-machines-list.module.scss";
import { useI18N } from "@src/language/language-context";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import renameIcon from "@src/assets/svg/rename-blue-icon.svg";
import saveIcon from "@src/assets/svg/save-right-blue-icon.svg";
import closeIcon from "@src/assets/svg/close-orange-icon.svg";
import { MachinesListDataTypes } from "@common/types/machines-list-types";
import { useEditSourceNameMachinesListHook } from "./use-edit-source-name-machines-list-hook";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";

interface EditSourceNameMachinesListPropTypes {
  machine: MachinesListDataTypes;
}

const cssClassName = "edit-source-name-machines-list";

export const EditSourceNameMachinesList = ({
  machine,
}: EditSourceNameMachinesListPropTypes) => {
  const i18n = useI18N();
  const {
    showInput,
    editSourceName,
    onKeyDownFunc,
    updateNewSourceName,
    saveSourceName,
    cancelSaveSourceName,
    newSourceName,
  } = useEditSourceNameMachinesListHook(machine);

  const texts = {
    save: i18n("modules.editSourceName.save"),
    edit: i18n("modules.editSourceName.edit"),
    cancel: i18n("modules.editSourceName.cancel"),
  };

  return (
    <>
      <span className={styles[cssClassName]}>
        {!showInput && (
          <span className={styles[`${cssClassName}__item-name-wrapper`]}>
            <span className={styles[`${cssClassName}__item-name`]}>
              {newSourceName || machine.name}
            </span>
            <RenderIfUserHasPermission permission="manage-sources">
              <span className={styles[`${cssClassName}__edit-text-button`]}>
                <IconButton
                  fun={(e) => editSourceName(e)}
                  icon={renameIcon}
                  tooltip={texts.edit}
                  variant="edit-save-close-icon"
                />
              </span>
            </RenderIfUserHasPermission>
          </span>
        )}
        {showInput && (
          <>
            <span
              className={styles[`${cssClassName}__item-name-input-wrapper`]}
            >
              <input
                type="text"
                value={newSourceName}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  updateNewSourceName(e, e.target.value);
                }}
                onKeyDown={(e) => {
                  onKeyDownFunc(e);
                }}
                className={styles[`${cssClassName}__item-name-input`]}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
            </span>
            <div className={styles[`${cssClassName}__buttons-wrapper`]}>
              <span className={styles[`${cssClassName}__save-text-button`]}>
                <IconButton
                  fun={(e) => saveSourceName(e)}
                  icon={saveIcon}
                  tooltip={texts.save}
                  variant="edit-save-close-icon"
                />
              </span>
              <span className={styles[`${cssClassName}__cancel-text-button`]}>
                <IconButton
                  fun={(e) => cancelSaveSourceName(e)}
                  icon={closeIcon}
                  tooltip={texts.cancel}
                  variant="edit-save-close-icon"
                />
              </span>
            </div>
          </>
        )}
      </span>
    </>
  );
};
